module.exports = __webpack_public_path__ + "images/85a0da86d8eb91ebbf6552bef219540f.activeCommunication.svg";